import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/beta-sticker.svg'
import _imports_1 from '../../assets/smart-search/search-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5b414c4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "beta-sticker",
  src: _imports_0,
  alt: "Gyre BETA sticker"
}, null, -1))
const _hoisted_2 = { class: "smart-search-bar-paper" }
const _hoisted_3 = {
  key: 0,
  class: "character-count"
}
const _hoisted_4 = { class: "smart-search-bar-button-container" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Search"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "text-danger text-center error-message"
}

import SearchResult from "./smart-search-result";
import { processSituations } from "./process-situations";
import { CmsDocumentTypes } from "../../services/cms/cms-type-configuration";
import CmsContentMap from "../../services/cms/cms-content-map";
import cms from "../../services/cms/cms";
import { Tooltip } from "uiv";
import { ref, computed, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'smart-search-bar',
  props: {
    question: { default: null }
  },
  emits: ["run"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable */
window["processSituations"] = processSituations;

const props = __props;

const emit = __emit;

// template refs
const queryTextAreaRef = ref<HTMLTextAreaElement | null>(null);
const sampleQueryTextAreaRef = ref<HTMLTextAreaElement | null>(null);

const hasFocus = ref(false);
const query = computed(() => props.question || window["_jyreQuery"] || "");
const lastQuery = ref<string | null>(null);

const sampleQuestion = ref("");
const exceededQueryLength = ref(false);

function updateTextAreaHeight(): void {
  const queryTextArea = queryTextAreaRef.value as HTMLTextAreaElement;
  const sampleQueryTextArea = sampleQueryTextAreaRef.value as HTMLTextAreaElement;
  queryTextArea.style.height = "0";
  sampleQueryTextArea.style.height = "0";

  const scrollHeight = Math.max(queryTextArea.scrollHeight, sampleQueryTextArea.scrollHeight);
  queryTextArea.style.height = scrollHeight + "px";
  sampleQueryTextArea.style.height = scrollHeight + "px";
}

function input() {
  updateTextAreaHeight();
}
const characterCount = computed(() => {
  return query.value.length;
});

const active = computed(() => {
  return (
    query.value !== lastQuery.value &&
    (query.value.trim() || (!hasFocus.value && !query.value.trim()))
  );
});

function queryChanged(): void {
  window["_jyreQuery"] = query.value;
  if (query.value.length > 1500) {
    exceededQueryLength.value = true;
  } else if (exceededQueryLength.value) {
    exceededQueryLength.value = false;
  }
}

function onKeyDown(event: KeyboardEvent): void {
  if (event.key === "Enter") {
    event.preventDefault();
    run();
  }
  hasFocus.value = true;
}

function onBlur(): void {
  hasFocus.value = false;
  setTimeout(updateTextAreaHeight, 10);
  exceededQueryLength.value = false;
}

const results = ref<SearchResult[]>(window["_jyreSearchResults"] || []);

function run() {
  if (query.value.length <= 1500) {
    const sanitizedQuery = query.value ? query.value.replace(/(\r\n|\n|\r)/gm, " ") : null;
    emit("run", sanitizedQuery || sampleQuestion.value);
  } else {
    exceededQueryLength.value = true;
  }
}

async function setSampleQuestion(): Promise<void> {
  const doc = await cms.getByUid(
    CmsDocumentTypes.CmsSmartSearchPrompts,
    CmsContentMap.smartSearch.promptsUid,
  );

  const sampleQuestions = doc?.data.prompts.split("\n");
  sampleQuestion.value = sampleQuestions[Math.floor(Math.random() * sampleQuestions.length)].trim();
}

onMounted(async () => {
  await setSampleQuestion();
  setTimeout(updateTextAreaHeight, 100);
  addEventListener("resize", updateTextAreaHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      "data-test": "smart-search-bar",
      class: _normalizeClass(["smart-search-bar", { 'query-error': exceededQueryLength.value }])
    }, [
      _createVNode(_unref(Tooltip), {
        text: "Gyre Recommends is a BETA feature, meaning we are still ironing out any rough edges",
        enterable: false
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("textarea", {
          "data-test": "smart-search-sample-question",
          ref_key: "sampleQueryTextAreaRef",
          ref: sampleQueryTextAreaRef,
          class: _normalizeClass(["smart-search-bar-textarea smart-search-bar-textarea-watermark", { hidden: query.value || hasFocus.value }]),
          rows: "1",
          disabled: "true",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sampleQuestion).value = $event)),
          "aria-hidden": ""
        }, null, 2), [
          [_vModelText, sampleQuestion.value]
        ]),
        _withDirectives(_createElementVNode("textarea", {
          "data-test": "smart-search-question",
          ref_key: "queryTextAreaRef",
          ref: queryTextAreaRef,
          class: "smart-search-bar-textarea smart-search-bar-user-textarea",
          rows: "1",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((query).value = $event)),
          onInput: input,
          onBlur: onBlur,
          onKeydown: _cache[2] || (_cache[2] = ($event: any) => (onKeyDown($event))),
          onChange: queryChanged,
          "aria-label": "Enter your question here"
        }, null, 544), [
          [_vModelText, query.value]
        ]),
        (query.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(characterCount.value) + " / 1500", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          "data-test": "smart-search-button",
          class: _normalizeClass(["btn smart-search-bar-button", { 'btn-default': !active.value, 'btn-primary': active.value }]),
          disabled: !active.value,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (run())),
          type: "button"
        }, _hoisted_7, 10, _hoisted_5)
      ])
    ], 2),
    (exceededQueryLength.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
          _createTextVNode(" We appreciate your enthusiasm, but this field has a character limit. Please reduce your input and try again. Characters used: "),
          _createElementVNode("span", null, _toDisplayString(characterCount.value) + " / 1500", 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})